/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-17 10:07:44
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, Button, TextStyle } from '@shopify/polaris';

import PlanWrapper from './plan-wrapper';
import PlanStatus from 'src/components/views/subscription/plan-status';
import PriceBox from 'src/components/views/subscription/price-box';
import PriceBoxLargePlan from 'src/components/views/subscription/price-box-large-plan';
import PriceSlider from 'src/components/views/subscription/price-slider';

import { getPlanInfo } from 'src/helpers/subscription-helper';

import type { WithI18nProps } from '@shopify/react-i18n';
import type { WrapperComponentPropsType } from './plan.type';

type ComposedProps = WrapperComponentPropsType & WithI18nProps;
class Plan extends Component<ComposedProps> {
  render() {
    const {
      i18n,
      host = '',
      tenantApp = {},
      selectedPlan = '',
      currentTotalProducts,
      status = '',
      correctPlan = {},
      dayLeft = '',
      regularExpiredAt = '',

      // Select price
      onSlidePlanName,
      onSlidePrice,
      onSlideProducts,

      // Discount code
      verifyDiscountCode,
      verifying,
      percent,
      termsConditions,

      // Subscribe
      subscribe,
      subscribing,

      // Show information page
      showInformation,
      handleChangeShowInformation,

      // allow subscribe plan v1
      allowToSubscribePlanV1,

      // allow to subscribe plus plan
      subscribePlusPlanV2 = false,

      // Check extra fee
      hasExtraFee,
      extraFeatures
    } = this.props;

    const { products = 1000, price = 19 } = correctPlan;

    // Value for old price information, get data with old
    let {
      name,
      label = 'AdminHTML.Subscription.Subscription.plan0',
      price: oldPrice = 0,
      products: selectedPlanProducts = 1000
    } = getPlanInfo(selectedPlan);

    // For offer Password Protected, display slider based on current product count
    selectedPlanProducts = name === 'offer0_1' ? products : selectedPlanProducts;

    const slideProductStart = [
      'subscribed',
      'specialDiscountExpiredSoon',
      'exceededWithNotification'
    ].includes(status)
      ? selectedPlanProducts
      : products;

    return (
      <Card sectioned>
        {/* Plan status | Product count */}
        <PlanStatus
          status={status}
          selectedPlan={selectedPlan}
          correctPlan={correctPlan}
          currentTotalProducts={currentTotalProducts}
          dayLeft={dayLeft}
          regularExpiredAt={regularExpiredAt}
          tenantApp={tenantApp}
          showInformation={showInformation}
          hasExtraFee={hasExtraFee}
        />

        {showInformation ? (
          <div className="information-pricing-V2">
            <p>
              {i18n.translate('AdminHTML.Subscription.Subscription.informationPricingV2_Text01', {
                t1: (
                  <TextStyle variation="strong">
                    <span style={{ color: 'var(--p-action-primary)' }}>
                      {i18n.translate(
                        'AdminHTML.Subscription.Subscription.informationPricingV2_Text01_t1',
                        {
                          nt_label: i18n.translate(label),
                          nt_old_price: oldPrice
                        }
                      )}
                    </span>
                  </TextStyle>
                )
              })}
            </p>

            <p>
              {i18n.translate('AdminHTML.Subscription.Subscription.informationPricingV2_Text02')}
            </p>
            <div className="btn-show">
              <Button primary onClick={handleChangeShowInformation}>
                {i18n.translate('AdminHTML.Subscription.Subscription.seeNewPricing')}
              </Button>
            </div>
          </div>
        ) : (
          <React.Fragment>
            {/* Price slider*/}
            <PriceSlider
              products={slideProductStart}
              onSlide={this.props.onSlide}
              allowToSubscribePlanV1={allowToSubscribePlanV1}
              subscribePlusPlanV2={subscribePlusPlanV2}
            />

            {/*Price box | Choose this plan*/}
            {onSlidePlanName === 'large' ? (
              <PriceBoxLargePlan />
            ) : (
              <PriceBox
                host={host}
                showDiscountCodeInput={false}
                currentTotalProducts={currentTotalProducts}
                price={onSlidePrice || price}
                totalProducts={onSlideProducts || products}
                correctPlan={correctPlan}
                selectPlanProducts={onSlideProducts}
                planId={onSlidePlanName}
                verify={verifyDiscountCode}
                loading={verifying}
                percent={percent}
                termsConditions={termsConditions}
                subscribe={subscribe}
                subscribing={subscribing}
                allowToSubscribePlanV1={allowToSubscribePlanV1}
                subscribePlusPlanV2={subscribePlusPlanV2}
                extraFeatures={extraFeatures}
              />
            )}
          </React.Fragment>
        )}
      </Card>
    );
  }
}

export default PlanWrapper(Plan);
